export const tableCellStyles = (padding = 8) => ({
  border: 'none',
  padding: `${padding}px`
});
